<template>
  <v-card class="criterio-container" draggable :class="{ dragged: isDragged }" v-on="$listeners">
    <mf-icon small color="#C3C8CD">drag_indicator</mf-icon>
    <span class="criterio-label">
      {{ criterio.label }}
      <news-badge v-if="showBadge" class="badges" />
    </span>
    <mf-icon class="arrow-icon-right" size="12" color="#78838E">arrow_forward_ios</mf-icon>
  </v-card>
</template>

<script>
export default {
  components: {
    NewsBadge: () => import('@/components/NewsBadge.vue'),
  },
  props: {
    criterio: {
      type: Object,
      required: true,
    },
    isDragged: {
      type: Boolean,
      default: false,
    },
    showBadge: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.criterio-container {
  height: 28px;
  border-radius: 2px;
  border: 1px solid $cinza-l60;
  background: $branco;
  cursor: move;
  display: flex;
  align-items: center;
  padding: 6px 11px 6px 3px;
  box-shadow: none !important;
}

.criterio-label {
  width: 100%;
  color: $cinza-d20;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  margin-left: 9px;
}

.badges {
  display: inline;
}

.dragged {
  background-color: $cinza-l80 !important;
}
</style>
